import React from 'react'

export default function Container10() {
  return (
    <div className='container my-5 py-5 text-center'>
        <h1 className='text-center my-3 fw-bold'>Mehr  Kunden  gewinnen  mit  PiiSCREEN</h1>
        <a href='https://werbenetzwerk.piiscreen.de/kontakt-formular' className='flinktext text-success1'><button className='btn btn-success my-3'>Jetzt Starten</button></a><br></br><a href="https://werbenetzwerk.piiscreen.de/kontakt-formular" className='my-3 fs-6 text-success1'>KOSTENLOSES ERSTGESPRÄCH</a>
        </div>
  )
}
